import { css } from 'styled-components';

export const sizes = {
    extraLarge: 1440,
    largeDevice: 1280,
    largportraitDevice: 1200,
    mediumDevice: 1024,
    portraitDevice: 1000,
    smalDevice: 768,
    mobileDevice: 576,
    exSmallDevice: 320,
    ipadAir: 820,
    ipad9thGenHeight: 1080,
    ipad9thGenWidth: 810
};

export default Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media (max-width: ${sizes[label]}px) {
            ${css(...args)};
        }
    `;
    return acc;
}, {});
